<!--Validación del estado de la conexión-->
@if (isSlowConnection) {
  <div class="alert">
    ⚠ La conexión de internet es lenta.
  </div>
}

<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<div class="filter-bar">
  <div class="filter-card">
    <app-search-pill placeholder="Nombre del contrato…" (search)="applyFilter($event)"></app-search-pill>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Estatus</mat-label>
      <mat-select [(value)]="contractStatus" (selectionChange)="statusFilter($event)">
        <mat-option value="Todos">Todos</mat-option>
        <mat-option value="Activo">Activo</mat-option>
        <mat-option value="Inactivo">Inactivo</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <app-filter-chips [chips]="statusChips" [count]="dataSource.filteredData.length" [total]="dataList?.length" noun="contratos" (remove)="clearStatus()" (clear)="clearStatus()"></app-filter-chips>
</div>

<div class="list-actions list-actions--page">
  <button mat-stroked-button (click)="pageLoad.refresh(getEntityData())"><mat-icon>refresh</mat-icon> Actualizar</button>
  @if (permissions?.create) {
    <button mat-flat-button color="primary" (click)="openDialog('create')">
      <mat-icon>add</mat-icon> Agregar contrato
    </button>
  }
</div>

<div class="indicators">
  <div class="dark-status">
    <span><b>Total: {{dataSource ? dataSource?.filteredData.length : 0}}</b></span>
  </div>
  <mat-paginator class="spacer" [pageSizeOptions]="[50]"></mat-paginator>
</div>

<mat-divider></mat-divider>

@if (!dataSource) {
  <mat-card class="container-card">
    <p>
      <b>No hay contratos disponibles.</b><br>
      Crea un contrato para continuar.
    </p>
  </mat-card>
}

@for (contract of dataSource?.filteredData; track contract; let i = $index) {
  <mat-card class="container-card">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>gavel</mat-icon> {{ contract['name'] }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div>
        <p>
          <span><b>Descripción: </b></span>
          {{contract.description ? contract.description : "Sin descripción"}}
        </p>
        <p>
          <span><b>Presupuesto: </b></span>
          {{contract.budget? (contract.budget | currency): "No especificado"}}
        </p>
        <p>
          <span><b>Fecha de inicio: </b></span>
          {{contract.startsOn? contract.startsOn: "No especificado"}}
        </p>
        <p>
          <span><b>Fecha de finalización: </b></span>
          {{contract.endsOn? contract.endsOn: "No especificado"}}
        </p>
        <p>
          <span><b>Estado del contrato: </b></span>
          {{contract.status? "Activo": "Inactivo"}}
        </p>
        <!-- Información de procedimientos -->
        @if (contract.procedures && contract.procedures.length > 0) {
          <p>
            <span><b>Procedimientos: </b></span>
            {{ contract.procedures.length }}
            <mat-icon
              inline
              class="info-icon"
              matTooltip="Este contrato tiene {{ contract.procedures.length }} procedimiento(s) asignado(s)">
              info
            </mat-icon>
          </p>
        }
      </div>
    </mat-card-content>
    <mat-divider inset></mat-divider>
    <mat-card-actions align="end">
      <button mat-icon-button [matMenuTriggerFor]="dotmenu" matTooltip="Más">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #dotmenu="matMenu">
        <button mat-menu-item color="primary" (click)="openContractSpecialty(contract)"> <mat-icon>folder_special</mat-icon> Especialidades</button>
        <button mat-menu-item color="primary" (click)="openContractPlace(contract)"> <mat-icon>place</mat-icon> Hospitales</button>
        <button mat-menu-item color="primary" (click)="openContractPrice(contract)"> <mat-icon>attach_money</mat-icon> Precios</button>
        <button mat-menu-item color="primary" (click)="openContractEquipment(contract)"> <mat-icon>build</mat-icon> Equipos</button>
        <button mat-menu-item color="primary" (click)="openContractProduct(contract)"> <mat-icon>category</mat-icon> Insumos</button>
        <button mat-menu-item color="primary" (click)="openContractProcedure(contract)"> <mat-icon>vaccines</mat-icon> Procedimientos</button>
        <button mat-menu-item color="primary" (click)="openContractPackages(contract)"> <mat-icon>inventory</mat-icon> Paquetes de servicio</button>
        <button mat-menu-item color="primary" (click)="openContractOperationRoom(contract)"> <mat-icon>monitor_heart</mat-icon> Quirofano</button>
      </mat-menu>
      <!-- Botón de Editar -->
      @if (permissions?.update) {
        <button
          color="primary"
          mat-icon-button
          matTooltip="Editar contrato"
          (click)="openDialog('update', contract, i)">
          <mat-icon>edit</mat-icon>
        </button>
      }
      <!-- Botón de Eliminar -->
      @if (permissions?.delete) {
        <button
          color="warn"
          mat-icon-button
          matTooltip="Eliminar contrato"
          (click)="deleteRecord(contract, i)">
          <mat-icon>delete</mat-icon>
        </button>
      }
      <!-- Toggle de Estado -->
      @if (permissions?.update) {
        <mat-slide-toggle
          [checked]="contract['status'] == true ? true : false"
          (change)="switchStatus($event, contract, i)">
          {{contract['status'] == true ? 'Desactivar' : 'Activar'}}
        </mat-slide-toggle>
      }
    </mat-card-actions>
  </mat-card>
}